/**
 * get-selected-options
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

export default function getSelectedOptions(select) {
    if (select.selectedOptions !== void 0) {
        return select.selectedOptions;
    }

    return [].filter.call(select.options, option => option.selected);
};
